const organizationName = "DPD";
const PATH_NAMES = {
  PROFILE: "MY_PROFILE",
  ASSESSMENT: "MY_ASSESSMENT",
  FEEDBACK: "MY_FEEDBACK",
  COMPETENCIES: "MY_COMPETENCIES",
  PREFERENCES: "MY_PREFERENCES",
  SITUATIONS: "MY_SITUATIONS",
  JOURNEY: "MY_JOURNEY"
}

const MY_PATH = {
  [PATH_NAMES.PROFILE]: {
    coloredImageUrl: require('../images/icons/alex/alex_myprofile.svg'),
    greyImageUrl: require('../images/icons/alex/alex_myprofile_grey.svg')
  },
  [PATH_NAMES.ASSESSMENT]: {
    coloredImageUrl: require('../images/icons/alex/alex_assessment.svg'),
    greyImageUrl: require('../images/icons/alex/alex_assessment_grey.svg')
  },
  [PATH_NAMES.FEEDBACK]: {
    coloredImageUrl: require('../images/icons/alex/alex_feedback.svg'),
    greyImageUrl: require('../images/icons/alex/alex_feedback_grey.svg')
  },
  [PATH_NAMES.COMPETENCIES]: {
    coloredImageUrl: require('../images/icons/alex/alex_competencies.svg'),
    greyImageUrl: require('../images/icons/alex/alex_competencies_grey.svg')
  },
  [PATH_NAMES.PREFERENCES]: {
    coloredImageUrl: require('../images/demo/alex-book-closed.png'),
    greyImageUrl: require('../images/demo/alex-book-closed.png')
  },
  [PATH_NAMES.SITUATIONS]: {
    coloredImageUrl: require('../images/icons/alex/alex_situations_grey.svg'),
    greyImageUrl: require('../images/icons/alex/alex_situations_grey.svg')
  },
  [PATH_NAMES.JOURNEY]: {
    coloredImageUrl: require('../images/icons/alex/alex_journey_grey.svg'),
    greyImageUrl: require('../images/icons/alex/alex_journey_grey.svg')
  }
}


// ALEX LIBRARY

const LEARNING_FORMATS = {
  WATCHING: "Watching",
  READING: "Reading",
  LISTENING: "Listening",
  INTERACTING: "Interacting",
  PARTICIPATION: "Participation"
}

const formatOptions = [
  { label: "Watching", value: LEARNING_FORMATS.WATCHING },
  { label: "Reading", value: LEARNING_FORMATS.READING },
  { label: "Listening", value: LEARNING_FORMATS.LISTENING },
  { label: "Interacting", value: LEARNING_FORMATS.INTERACTING },
  { label: "Participation", value: LEARNING_FORMATS.PARTICIPATION },
];

const learningFormatIcons = {
  [LEARNING_FORMATS.WATCHING]: require('../images/icons/alex/Watching.svg'),
  [LEARNING_FORMATS.READING]: require('../images/icons/alex/Reading.svg'),
  [LEARNING_FORMATS.LISTENING]: require('../images/icons/alex/Listening.svg'),
  [LEARNING_FORMATS.INTERACTING]: require('../images/icons/alex/Interacting.svg'),
  [LEARNING_FORMATS.PARTICIPATION]: require('../images/icons/alex/Participation.svg')
}
const durationTypes = [
  { label: "Micro (0-15 min)", value: "Micro" },
  { label: "Mini (15-60 min)", value: "Mini" },
  { label: "Small (1-2 hrs)", value: "Small" },
  { label: "Macro (2+ hrs)", value: "Macro" },
];
const languageTypes = [
  { label: "English", value: "EN" },
  { label: "Português", value: "PT"},
  { label: "Française", value: "FR" },
  { label: "Deutsche", value: "DE"},
  { label: "Española", value: "ES"},
  { label: "Nederlands", value: "NL"},
  { label: "Italiana", value: "IT"},
];
// const dpdCategory =[
//   { label: "Shares information", value: "Shares information" },
//   { label: "Integrates diverse views", value: "Integrates diverse views" },
//   { label: "Willing to make mistakes", value: "Willing to make mistakes" },
//   { label: "Prioritizes effectively", value: "Prioritizes effectively" },
//   { label: "Creates sustainable value", value: "Creates sustainable value" },
//   { label: "Works cooperatively", value: "Works cooperatively" },
//   { label: "Improves the quality of work processes", value: "Improves the quality of work processes" },
//   { label: "Handles high tension situations", value: "Handles high tension situations" },
//   { label: "Customer Focused", value: "Customer Focused" },
//   { label: "Adapts to the environment", value: "Adapts to the environment" },
//   { label: "Proactive", value: "Proactive" },
//   { label: "Seizes development opportunities ", value: "Seizes development opportunities " },
//   { label: "Takes decisions ", value: "Takes decisions" },
//   { label: "Champions ideas ", value: "Champions ideas" },
//   { label: "Encourages engagement from all stakeholders", value: "Encourages engagement from all stakeholders" },
//   { label: "Formulates a competitive strategy", value: "Formulates a competitive strategy" },
//   { label: "Effectively manages from a distance", value: "Effectively manages from a distance" },
//   { label: "Evaluate goals and performance against strategic plan", value: "Evaluate goals and performance against strategic plan" },
// ]
const GBCharacteristic =[
  { label: "Willing Risk Taker", value: "Willing Risk Taker" },
  { label: "Energetic Driver", value: "Energetic Driver" },
  { label: "Conflict Confronter", value: "Conflict Confronter" },
  { label: "Practical Fixer", value: "Practical Fixer" },
  { label: "Flexible Character", value: "Flexible Character" },
  { label: "Methodical Organizer", value: "Methodical Organizer" },
  { label: "Calming Influence", value: "Calming Influence" },
  { label: "Compassionate Carer", value: "Compassionate Carer" },
  { label: "Responsible Citizen", value: "Responsible Citizen" },
  { label: "Constant Learner", value: "Constant Learner" },
  { label: "Imaginative Mind", value: "Imaginative Mind" },
  { label: "The Big Picture Thinker", value: "The Big Picture Thinker" },
  { label: "Effective Negotiator", value: "Effective Negotiator" },
  { label: "Sound Decision Maker", value: "Sound Decision Maker" },
  { label: "People Manager", value: "People Manager" },
  { label: "Motivational Cheerleader", value: "Motivational Cheerleader" },
  { label: "Social Networker", value: "Social Networker" },
  { label: "Skilled Communicator", value: "Skilled Communicator" },
]
const userSegments = [
  {
    label: "Level",
    options: ["Professional", "People Coach", "Process Integrator"],
  },
  {
    label: "Function",
    options: ["Manager", "Associate", "Assistant", "Developer"],
  },
  {
    label: "Department",
    options: ["IT", "Marketing", "HR"],
  },
  {
    label: "Username",
    options: ["username1", "username2"],
  },
  {
    label: "Identified Gaps",
    options: ["Communication", "Public speaking", "Writing"],
  },
]

export { PATH_NAMES, MY_PATH, formatOptions, learningFormatIcons,  durationTypes,languageTypes,GBCharacteristic };
